package features.members.handlers

import kotlinx.browser.document
import shared.ui.ModalManager

// Member Modal Functions
fun showAddMemberModal() {
    val today = kotlin.js.Date().toISOString().split("T")[0]
    (document.getElementById("add-member-join") as? org.w3c.dom.HTMLInputElement)?.value = today
    ModalManager.show("add-member-modal")
}

fun openEditMember(memberId: String) {
    console.log("Opening edit member for ID: $memberId")
    val teamId = AppState.currentTeam?.id
    if (teamId == null) {
        console.log("No current team ID")
        return
    }
    
    val member = AppState.members[teamId]?.find { it.id == memberId }
    if (member == null) {
        console.log("Member not found: $memberId")
        return
    }
    
    console.log("Found member:", member.name)
    (document.getElementById("edit-member-id") as? org.w3c.dom.HTMLInputElement)?.value = member.id
    (document.getElementById("edit-member-name") as? org.w3c.dom.HTMLInputElement)?.value = member.name
    (document.getElementById("edit-member-email") as? org.w3c.dom.HTMLInputElement)?.value = member.email
    (document.getElementById("edit-member-role") as? org.w3c.dom.HTMLSelectElement)?.value = member.role
    
    ModalManager.show("edit-member-modal")
}

fun openMemberSchedule(memberId: String) {
    console.log("Opening schedule for member: $memberId")
    // Just show the modal - the modal will handle rendering
    ModalManager.show("member-schedule-modal")
}
